<div id="chart-container" class="w-100 h-100">
  <ng-container *ngIf="isDataValid(); else noDataTemplate">
    <p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
  </ng-container>

  <ng-template #noDataTemplate>
    <app-no-data></app-no-data>
  </ng-template>
</div>